import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { Stack, Typography } from '@mui/material';
import { map } from 'lodash';
import { PenStyled } from './styles';
import { InventoryListViewProps } from './types';

export const InventoryListViewExcluded = ({
  data,
  onAdvanced,
}: InventoryListViewProps) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Typography variant="body2">{map(data, 'value').join(', ')}</Typography>
    <PenStyled
      role="button"
      onClick={() => {
        onAdvanced();
      }}
      icon={faPen}
    />
  </Stack>
);
